module.exports = __webpack_public_path__ + "img/back-circle.e18d9c75.svg";